// extracted by mini-css-extract-plugin
export default {"sliderContainer":"CourseSection_sliderContainer__xCew2"};